import { GuestGuard } from "app/features/authentication/guards/GuestGuard";
import LoginScreen from "app/screens/authentication/LoginScreen";

export default function Index() {
  return (
    <GuestGuard>
      <LoginScreen />
    </GuestGuard>
  );
}
